export const LOCAL_STORAGE_KEY = 'speed-test-history';
export const API_URL = `${REACT_APP_API_BASE_URL}/client_api/v1`;
export const TABS = {
  SPEED_TEST: 'speedTest',
  ALL_RESULTS: 'allResults',
  HISTORY: 'history',
  OVERVIEW: 'overview',
};
